<template>
  <div class="factory-wrapper">

    <custom-table
      v-if="hasRes('factory_index')"
      :data="factoryList"
      @data-change="updateTableData">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>

        <el-table-column
          prop="factory_id"
          label="厂商ID"
          sortable="custom"
          >
        </el-table-column>

        <el-table-column
          prop="name"
          label="厂商名称"
          sortable="custom"
          >
        </el-table-column>
    </custom-table>

    <custom-paginate
      :count="factoryCount"
      v-if="hasRes('factory_index')"
      @page-change="updateTableData">
    </custom-paginate>

  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { SET_LOADING } from '@/store/modules/table'

import CustomTable from '@/components/CustomTable'
import CustomPaginate from '@/components/CustomPaginate'

export default {
  name: 'Factory',
  components: {
    CustomTable,
    CustomPaginate
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState('factory', [
      'factoryList',
      'factoryCount'
    ]),
    ...mapState('table', [
      'page',
      'pageSize',
      'sort',
      'filters',
      'loading'
    ]),
    ...mapGetters('opUser', [
      'hasRes'
    ])
  },
  methods: {
    ...mapMutations('table', [
      SET_LOADING
    ]),
    ...mapActions('factory', [
      'getFactories'
    ]),

    updateTableData () {
      if (!this.hasRes('factory_index')) return

      this.setLoading(true)

      this.getFactories({
        page: this.page,
        pageSize: this.pageSize,
        sort: this.sort,
        filters: this.filters
      }).then(res => {
        this.setLoading(false)
      }).catch(err => {
        console.log(err)
        this.setLoading(false)

        this.$message({
          type: 'error',
          message: '获取商户列表失败'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/base";
</style>



// WEBPACK FOOTER //
// src/pages/op/factory/Factory.vue